export default [
  {
    for: 'artist',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: ['text'],
  },
];
